__turbopack_context__.v({
  "content": "wpPost-module-scss-module__rkdJGq__content",
  "title": "wpPost-module-scss-module__rkdJGq__title",
  "wpPost": "wpPost-module-scss-module__rkdJGq__wpPost",
});
